import { Component } from '@angular/core';

import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';

@Component({
	selector: 'app-reservation-refresh',
	templateUrl: './reservation-refresh.component.html',
	styleUrls: ['./reservation-refresh.component.css'],
})
export class ReservationRefreshComponent {
	loader = false;
	number: number;
	error: string;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
	) {}

	submit() {
		this.loader = true;
		this.error = null;
		this.api.command('/reservation/refresh', { number: this.number }, (result, error) => {
			this.loader = false;
			if (error) {
				return;
			}
			this.number = null;
			this.infobox.success('Pomyślnie odświeżono rezerwację');
		});
	}
}
